module.exports = __webpack_public_path__ + "static/media/20.90b62a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/20.png
// module id = 980
// module chunks = 0